"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrailingSlot = exports.LeadingSlot = exports.InteractiveArea = exports.HeaderSideAreaFlexContainer = exports.HeaderSideArea = exports.HeaderArea = exports.Column = exports.BottomArea = void 0;
var _SlotSizes = require("./SlotSizes.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _index = require("../../styles/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InteractiveArea = exports.InteractiveArea = _styledComponents["default"].div.withConfig({
  displayName: "Areas__InteractiveArea",
  componentId: "sc-8gfrea-0"
})(["& button,& a,& [role='button'],& [role='link']{position:relative;z-index:1;}"]);
var HeaderSideArea = exports.HeaderSideArea = _styledComponents["default"].div.withConfig({
  displayName: "Areas__HeaderSideArea",
  componentId: "sc-8gfrea-1"
})(["grid-column:1;gap:", ";", ""], (0, _index.cssSpacing)('base', '16px'), function (_ref) {
  var $layout = _ref.$layout,
    $hasBodyOrFooter = _ref.$hasBodyOrFooter;
  return $layout === 'wide' && $hasBodyOrFooter && (0, _styledComponents.css)(["grid-row:span 2;"]);
});

/* since the side area can span multiple rows (see above) we create a small
 * inner layout here to handle centering the Leading slot next to Media without
 * centering both items within the larger grid area that can span 2 rows */
var HeaderSideAreaFlexContainer = exports.HeaderSideAreaFlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "Areas__HeaderSideAreaFlexContainer",
  componentId: "sc-8gfrea-2"
})(["display:flex;gap:", ";align-items:center;height:100%;", ""], (0, _index.cssSpacing)('tighter', '12px'), function (_ref2) {
  var $layout = _ref2.$layout;
  return $layout === 'wide' && (0, _styledComponents.css)(["height:auto;"]);
});
var HeaderArea = exports.HeaderArea = _styledComponents["default"].div.withConfig({
  displayName: "Areas__HeaderArea",
  componentId: "sc-8gfrea-3"
})(["", ""], function (_ref3) {
  var $horizontalGap = _ref3.$horizontalGap;
  return (0, _styledComponents.css)(["grid-column-end:-1;gap:", ";align-items:center;display:flex;justify-content:space-between;"], (0, _index.isSpacer)($horizontalGap) ? (0, _index.cssSpacing)($horizontalGap) : $horizontalGap);
});
var BottomArea = exports.BottomArea = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__BottomArea",
  componentId: "sc-8gfrea-4"
})(["", ""], function (_ref4) {
  var $layout = _ref4.$layout,
    $hasLeadingOrMedia = _ref4.$hasLeadingOrMedia;
  return $layout === 'wide' && $hasLeadingOrMedia ? (0, _styledComponents.css)(["grid-column:2;"]) : (0, _styledComponents.css)(["grid-column:1/-1;"]);
});
var Column = exports.Column = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__Column",
  componentId: "sc-8gfrea-5"
})(["", ""], function (_ref5) {
  var $size = _ref5.$size,
    _ref5$$titleGap = _ref5.$titleGap,
    $titleGap = _ref5$$titleGap === void 0 ? _SlotSizes.titleSpacing[$size] : _ref5$$titleGap;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;gap:", ";align-items:flex-start;"], (0, _index.isSpacer)($titleGap) ? (0, _index.cssSpacing)($titleGap) : $titleGap);
});
var LeadingSlot = exports.LeadingSlot = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__LeadingSlot",
  componentId: "sc-8gfrea-6"
})(["flex-shrink:0;align-self:stretch;display:flex;align-items:center;"]);
var TrailingSlot = exports.TrailingSlot = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__TrailingSlot",
  componentId: "sc-8gfrea-7"
})(["flex-shrink:0;align-self:stretch;display:flex;align-items:center;"]);